import { useQuery } from '@apollo/client';

import { MY_TARGETED_USERS } from '../graphql/query/myTargetedUsersQuery.graphql';

export const useMyTargetedUsersQuery = (eventId: string) => {
  return useQuery(MY_TARGETED_USERS, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
